import {DnsProviderKind} from './types';

// One place, because three components render a provider name (the table column,
// the detail Profile, and the failure banner) and three copies of the same map
// is how one of them silently keeps saying "ROUTE53" after the others stop.
export const PROVIDER_LABELS: Record<string, string> = {
    ROUTE53: 'Route 53',
    CLOUDFLARE: 'Cloudflare',
    FAKE: 'Fake (test)',
};

export const PROVIDER_COLORS: Record<string, string> = {
    ROUTE53: 'orange',
    CLOUDFLARE: 'yellow',
    FAKE: 'gray',
};

// Falls back to the RAW ENUM rather than blank or "Unknown": a provider added
// to the schema before this map catches up should still name itself. A zone
// whose provider renders as an empty cell looks like missing data.
export const providerLabel = (provider: DnsProviderKind | string): string =>
    PROVIDER_LABELS[provider] ?? provider;

export const providerColor = (provider: DnsProviderKind | string): string =>
    PROVIDER_COLORS[provider] ?? 'blue';
